import BusLayout from "./BusLayout";

export default BusLayout;